<template>
    <div :class="['of-content-2', content2.video != '#' ? 'of-content2-video' : 'of-content2-img']">
        <div v-if="content2.video != '#'" class="video-wrapper"   >
            <iframe
                class="video"
                :src="content2.video"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen
                scrolling="no"
            ></iframe>
        </div>
        <img v-else class="img-left" :src="content2.mainSvg" alt="" srcset="">
        <div class="content">
            <h1 class="title" v-html="content2.title"></h1>
            <p class="text" v-html="text"></p>
            <diV class="affl-grid">
                <div class="affl-label" v-html="content2.affiliate.text"></div>
                <div class="affl-link" v-html="content2.affiliate.link"></div>
                <div class="affl-button" v-html="content2.affiliate.button" @click="copyToClipboard()" :data-ba-i="content2.baIntelligenceTag"></div>
                <textarea type="text" v-model="content2.affiliate.link" ref="link-input"></textarea>
            </diV>
        </div>
    </div>
</template>


<script>
    export default {
        name: "of-content-2",
        props: ["view"],
        components: {},
        data() {
            return {
                title: '&ldquo;You have never seen anything like what we are bringing to the marketplace&rdquo;',
                name: 'Erick Salgado',
                occupation: 'Builderall CEO / Founder',
                mainSvg: "/internacional/public/office4/img/onboarding-funnel/content-2/CEO.svg",
                video: "https://videomng.builderall.com/embed/NSG8aNMz2L?autoplay=2&countdown=1&controls=1&allowpause=1",
                affiliate: {
                    text: 'Your Funnel Club Affiliate Link:',
                    link: 'https://builderall.affiliados/978752',
                    button: 'copy'
                },
                baIntelligenceTag: 'fc-c2-copy-affiliate-link'
            }
        },
        computed: {
            content2: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            },
            text: function () {
                return `${this.content2.name}<br/>${this.content2.occupation}`
            }
        },
        methods: {
            pageRedirect: function (link){
                window.open(link, '_blank')
            },
            copyToClipboard: function(){
                /* deve ser executado dentro de um evento para funcionar*/
                this.$refs['link-input'].focus()
                this.$refs['link-input'].select()
                try {
                    let successful = document.execCommand('copy', false, this.content2.affiliate.link);
                    let msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Copying text command was ' + msg);
                } catch (err) {
                    console.log('Oops, unable to copy');
                }
            }
        },
        mounted() {
            
        },
        created() {

        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../../../../scss/office";

    .of-content2-img{ /* imagem */
        font: inherit;
        min-height: 75.4em; /* 754px */
        .content{
            font: inherit;
            width: 50%; /* 756px */
            max-width: 50%; /* 756px */
            height: 56.25%;

            position: absolute;
            top: 0;
            right: 0;

            padding: 8.2em 3.8em 0 0; /* 82px 38px 0 0 */

            .title{
                font: inherit;
                font-size: 6em!important;; /* 64.15010652px */
            }
            .affl-grid{
                font: inherit;
                 margin: 0 0 1.832860186em 6em; /* 18.32860186px 60px*/
            }
        }
    }
    .of-content2-video{ /* video */
        font: inherit;
        min-height: 56.25%; /* 16:9 */
        .content{
            font: inherit;
            width: 100%; /* 756px */
            max-width: 100%; /* 756px */
            height: auto!important;

            position: relative!important;

            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: auto;
            align-items: center;
            align-content: stretch;
            justify-items: stretch;
            justify-content: space-evenly;
            column-gap: 6.4em;

            padding: 4em 2.4em 0 2.4em; /* 40px 24px 0 24 */
            
            .title{
                font: inherit;
                font-size: 2.9em!important;
                text-align: left;
            }
            .text{
                display: none;
            }

            .affl-grid{
                font: inherit;
                margin: 0 0 1.832860186em 0; /* 18.32860186px 60px*/
            }

        }
    }
    
    .of-content-2{
        font: inherit;
        text-align: right;
        border: 1px $of-color1 solid;
        border-radius: 0.4em;

        margin-bottom: 0.8em!important; /*8px*/
        background-color: $of-color1;
        position: relative;        

        display: grid;
        align-items: center;
        overflow: hidden;

        .video-wrapper {
            font: inherit;
            position: relative;
            z-index: 0;

            width: 100%; /* 16:9 */
            padding-bottom: 56.25%;/* 16:9 */

            background-color: $of-color12;

            .video{
                font: inherit;
                overflow: hidden!important;
                
                position: absolute;
                top: 0;
                left: 0;

                width: 100%;
                height: 100%;
            }
        }
        .img-left{
            font: inherit;
            z-index: 0;

            position: absolute;
            top: 0.8em;
            left: 1em; /* 17px */

            height: 100%;
            width: auto;
            max-width: 100%;
        }

        .content{
            font: inherit;
            z-index: 1;            

            .title{
                font: inherit;
                color: $of-color3;
                background-color: transparent;

                font-weight: 900;
                line-height: 1.2;

                margin: 0 0 0.75em 0; /* 0 0 45px 0 */
                padding: 0;

            }

            .text{
                font: inherit;
                color: $of-color3;
                background-color: transparent;

                font-size: 1.37464514em; /* 13.7464514px*/
                font-weight: 900;
                line-height: 1.2;

                margin: 0 0 3.273572116em 0; /*0 0 45px 0 */
                padding: 0;
            }

            .button {
                /* removido */
                font: inherit;
                font-size: 2.016146205em; /* 20.16146205px */
                font-weight: 700;
                display: inline-block;
                background: $of-color4;
                padding: 0.717727273em 1.959545455em; /* 15.79px 43.11px */
                color: $of-color3;
                border-radius: 4px;
                transition: 1s all ease;
                margin: 0 0 1.857142857em 0; /*26px */
                text-align: center;
                position: relative;
                &:hover {
                    cursor: pointer;
                    box-shadow: 0px 0px 7px -2px $of-color1;
                }
            }


            .affl-grid{
                font: inherit;

                display: grid;
                grid-template-columns: 8fr 2fr;
                grid-template-rows: auto;
                justify-items: stretch;
                align-items: stretch;
                justify-content: stretch;
                align-content: stretch;
                row-gap: 0.916430093em; /* 9.16430093px*/
                column-gap: 0.4em; /* 4px */

                
                
                .affl-label{
                    font: inherit;

                    grid-row-start: 1;
                    grid-column-start: 1;

                    font-size: 2.016146205em; /* 20.16146205 */
                    font-weight: 900;
                    line-height: 1.2;
                    color: $of-color3;
                    text-align: right;
                    text-transform: uppercase;

                    padding: 0 0.694394085em; /* 0 14px */
                }

                .affl-link{
                    font: inherit;

                    grid-row-start: 2;
                    grid-column-start: 1;

                    font-size: 2.199432224em; /* 21.99432224px */
                    font-weight: 700;
                    line-height: 1.2;
                    text-align: center;

                    background-color: $of-color3;
                    color: $of-color20;
                    box-shadow: 0px 0.166666667em 0.166666667em rgba($of-color12, 0.25); /* 0 4px 4px */
                    border-radius: 0.166666667em; /* 4px */
                    padding: 0.636527911em 0.636527911em; /* 14px 14px */
                }
                .affl-button{
                    font: inherit;
                    grid-row-start: 2;
                    grid-column-start: 2;

                    color: $of-color3;
                    background-color: $of-color4;

                    font-size: 1.832860186em; /*18.32860186*/
                    font-weight: 900;
                    line-height: 1.2;
                    text-transform: uppercase;

                    box-shadow: 0px 0.2em 0.2em rgba($of-color12, 0.25); /* 0 4px 4px */
                    border-radius: 0.2em; /* 4px */
                    padding: 0.763833494em 0.763833494em; /* 14px 14px */

                    display: flex;
                    align-items: center;
                    justify-content: center;
                    &:hover{
                        cursor: pointer;
                    }
                }
                textarea{
                    opacity: 0;
                    width: 1px;
                    height: 1px;
                }

            }

        }
    }

    @media (max-width: 1024px) { /*tablets */
        .of-content2-video{
            .content{
                display: block;
                max-width: 90%;
                padding-top: 4em!important;
                
                .title{
                    font-size: 6em!important;
                    text-align: center;
                    
                }
                .text{
                    display: block;
                }
            }
        }
        .of-content-2{
            font: inherit;

            position: relative;
            text-align: center;

            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: repeat(2, auto);
            align-items: start;
            justify-items: center;
            column-gap: 0;

            .img-left{
                font: inherit;
                position: relative;
                top: 0;
                left: 0;

                grid-column-start: 1;
                grid-column-end: 2;
                grid-row-start: 1;
                grid-row-end: 2;

                width: 90%;
                height: auto;

                padding-top: 6.2em; /* 62px */
            }

            .content{
                font: inherit;
                position: relative;
                top: 0;
                right: 0;

                grid-column-start: 1;
                grid-column-end: 2;
                grid-row-start: 2;
                grid-row-end: 3;

                min-width: 90%;

                padding: 0 0 6.2em 0; /* 62px */

                .text{
                    font-size: 1.8em!important;
                    line-height: 1.5;
                }

                .button {
                    display: block;
                    margin: 0;
                }
                .affl-grid{
                    margin-left: 0;
                    .affl-label{
                        grid-column: 1 / span 2;
                        text-align: center;
                    }
                }
            }
        }
    }
    @media (max-width: 768px) { /* mobile */
        .of-content-2{
            font: inherit;
            .content{
                font: inherit;
                .affl-grid{
                    margin: 0;
                    grid-template-columns: 7fr 3fr;
                    div{
                        word-break: break-all;
                    }

                    .affl-label{
                        grid-column: 1 / span 2;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-2/index.vue